import { defineStore } from 'pinia'
import { MenuItem } from 'primevue/menuitem'
import { useViteEnvironment } from '@/shared/composables/useViteEnvironment'

export const useNavStore = defineStore('nav-store', {
  state: () => ({
    menuItems: [] as MenuItem[],
    /**
     * Overrides the topbar title / last breadcrumb label — set by detail pages once their entity is
     * loaded (e.g. the company name). Managed by useTopBarTitle, which clears it when the owning
     * page unmounts.
     */
    crumbOverride: null as string | null,
  }),
  actions: {
    fill() {
      /*
       * The rest of the sidebar is composed from the user's menu preferences (see useComposedMenu);
       * only the always-present entries live here: the Homepage, and outside production the Stand-in
       * actions (a test-only tool that must never be configurable onto the production menu).
       */
      this.menuItems = [
        {
          label: 'Homepage',
          icon: 'fa-regular fa-house',
          route: {
            name: '/homepage/Homepage',
          },
        },
        ...(useViteEnvironment().isProd
          ? []
          : [
            {
              label: 'Stand-in acties',
              icon: 'fa-regular fa-user-secret',
              route: {
                name: '/tools/StandIn',
              },
            },
          ]),
      ]
    },
    setCrumbOverride(label: string) {
      this.crumbOverride = label
    },
    clearCrumbOverride() {
      this.crumbOverride = null
    },
  },
})
